import { defineComponent as _defineComponent } from 'vue'
import { Ref, onUnmounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CCollapse',
  props: {
    title: null,
    resizable: { type: Boolean }
  },
  setup(__props: any) {



const contentRef: Ref<Element | null> = ref(null);
const itemContainerSize = ref(250);

onUnmounted(() => {
    onStopResizeItemContainerSize();
});

const onStartResizeItemContainerSize = () => {
    window.addEventListener('mousemove', onHandleResizeItemContainerSize);
    window.addEventListener('mouseup', onStopResizeItemContainerSize);
};

const onHandleResizeItemContainerSize = (event: MouseEvent) => {
    const newHeight = event.clientY - contentRef.value!.getBoundingClientRect().bottom;

    if (newHeight === Infinity || newHeight === -Infinity) return;

    const newHeightContainer = itemContainerSize.value + newHeight;
    const controlHeight = document.querySelector('.layout-main')?.getBoundingClientRect().height || 0;

    if (newHeightContainer > controlHeight) return;

    itemContainerSize.value = newHeightContainer;
};

const onStopResizeItemContainerSize = () => {
    window.removeEventListener('mousemove', onHandleResizeItemContainerSize);
    window.removeEventListener('mouseup', onStopResizeItemContainerSize);
};

return { __sfc: true,contentRef, itemContainerSize, onStartResizeItemContainerSize, onHandleResizeItemContainerSize, onStopResizeItemContainerSize }
}

})